import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  campFeaturedImg: {
    width: '100%',
    maxHeight: '250px',
    objectFit: 'cover',
    objectPosition: '100% 24%',
  },
  featuredImg: {
    width: '100%',
    maxHeight: '250px',
    objectFit: 'cover',
  },
  root: {
    padding: '0 80px 45px 80px',
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px 60px 20px',
    },
  },
  title: {
    margin: '0 0 1rem',
    fontSize: '36px',
    fontWeight: 700,
    [theme.breakpoints.up('xs')]: {
      letterSpacing: '-1px',
      lineHeight: '1.3',
    },
  },
  divider: {
    margin: '30px',
  },
  cardSubtitle: {
    fontSize: '14px',
    fontWeight: 700,
    color: 'rgba(0, 0, 0, 0.54)',
  },
  bodyText: {
    fontWeight: 600,
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  sessionText: {
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  cardText: {
    fontSize: '16px',
    fontWeight: 700,
    color: 'rgba(0, 0, 0, 0.87)',
  },
  cardSubtext: {
    fontSize: '16px',
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.87)',
    fontStyle: 'italic',
  },
  captionText: {
    fontSize: '14px',
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.54)',

  },
  registerBox: {
    minWidth: '300px',
    backgroundColor: '#FFF',
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
  },
  registerButton: {
    [theme.breakpoints.up('md')]: {
      marginTop: '20px',
      width: '100%',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '&:hover': {
      color: '#FFF',
    },
  },
  messageButton: {
    height: '40px',
    marginTop: '36px',
  },
  registerMobileSection: {
    zIndex: '10',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'fixed',
    padding: '20px',
    bottom: 0,
    left: 0,
    background: '#fff',
    justifyContent: 'space-between',
    border: '1px solid #E0E0E0',
  },
  profileBtn: {
    padding: 0,
    height: 'unset',
    textTransform: 'uppercase',
  },
  linkButton: {
    textTransform: 'uppercase',
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  formContainer: {
    maxWidth: '600px',
    textAlign: 'center',
    background: '#f7f7f7',
    padding: theme.spacing(8),
    height: 'auto',

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
    },

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  formInput: {
    width: '100%',
    '& fieldset': {
      borderRadius: '8px',
      border: 'none',
      boxShadow: '0px 4px 36px 0px rgba(0, 10, 22, 0.13)',
    },
  },
  iconBig: {
    color: theme.palette.primary.main,
    background: '#EEEEEE',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    pointerEvents: 'none',
  },
  fitContent: {
    width: 'fit-content',
  },
  checkboxLabel: {
    color: theme.palette.grey.dark,
    fontWeight: 500,
    fontSize: '14px',
    '& a': {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
    },
  },
  marketingLink: {
    color: '#3268A7',
    textDecoration: 'underline',
  },
  proceedingText: {
    marginBottom: '1rem',
  },
  coachTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    marginTop: theme.spacing(1),
    color: theme.palette.primary.dark,
  },
  coachAvatar: {
    border: '2px solid #DBD2C1',
    width: '64px',
    height: '64px',
    marginTop: '0.25rem',
    marginRight: '0.75rem',
    fontSize: '2.5rem',
    color: '#fff',
    backgroundColor: '#d8d8d8',
  },
  descriptionWrapper: {
    '& a': {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
    },
  },
}))
